import "./ActualPages.css";
import { Link } from "react-router-dom";
import Footer from "../pages/Footer.js"
import React from "react";
import blogList from "../assets/constants/blogList";
import blurMobile from '../assets/blurMobile.png';
import blurDesktop from '../assets/blurDesktop.png';

function Blogs(props) {

  const blurClass = props.isMobile ? "blurImageMobile" : "blurImageDesktop";
  const blur = props.isMobile ? blurMobile : blurDesktop;


  return (
            <div className="blog">
            <img className={blurClass} src={blur} alt="hot pink gradient"></img>
                <Link className="link" to="/" >
                  <p className="backButton"> back to home </p>
                </Link>
            <h1 className="myWork"> CREATIVE PROJECTS </h1>
           <p className="headerSubText"> I love designing and building things - I've written short stories on a few of my project here. All content is original and AI free - I do not support generative AI in its current form. </p>
           <div className="blogList">
            {blogList.map((blog, index) => (
                <a className="href individualBlog" href={"/blog/" + blog.shortName}>
                <div className="storyPreviewBox">
                    <h1 className="blogTitle"> {blog.title}</h1>
                    {blog.mainImage}
                </div>
                </a>
            ))}
            </div>
            <Footer/>
        </div>
  );
}

export default Blogs;
